<template>
  <div class="container">
    <sys-filter :filters.sync="filters" :server="true" :items="items" :filtered_items.sync="filtered_items" @getItems="getItems"/>
    <div class="row pb-5">
      <sys-widget title="Cantidad de Usuarios" :content="meta.total" icon="users" />
    </div>
    <sys-server-table :headers="headers" :tableData="tableData" :pagination="pagination" :items="items" :title="title" :error_message="error_message" :detail_route="detail_route" :create_route="create_route" @getItems="getItems" />
  </div>
</template>

<script>
import usersService from '@/services/users'
import SysServerTable from '@/components/shared/ServerTable'
import SysFilter from '@/components/shared/Filter'
import SysWidget from '@/components/shared/Widget'

export default {
  name: 'Users',

  components: { SysServerTable, SysFilter, SysWidget },
  created () {
    this.getItems()
  },
  data () {
    return {
      title: 'Usuarios',
      headers: [
        { text: 'Id', value: 'id' },
        { text: 'Nombre', value: 'name' },
        { text: 'Usuario', value: 'username' },
        { text: 'Correo Electrónico', value: 'email' },
        { text: 'Plataforma', value: 'platform' }
      ],
      items: [],
      filtered_items: [],
      error_message: 'There\'s nothing to show :c',
      detail_route: 'user',
      create_route: 'user_create',
      tableData: {
        draw: 0,
        length: 10,
        search: '',
        column: 0,
        dir: 'desc'
      },
      meta: {
        total: 0,
        total_amount: 0
      },
      pagination: {
        lastPage: '',
        currentPage: '',
        total: '',
        links: {},
        from: 1,
        to: 10
      },
      filters: [
        {
          id: 'name',
          name: 'Nombre Usuario',
          hint: 'Usuario',
          icon: 'user',
          type: 'text',
          value: '',
          validator: (item, value) => item.name.toLowerCase().includes(value.toLowerCase())
        },
        {
          id: 'email',
          name: 'Correo Electrónico',
          hint: 'Email',
          icon: 'envelope',
          type: 'text',
          value: '',
          validator: (item, value) => item.email.toLowerCase().includes(value.toLowerCase())
        },
        {
          id: 'role',
          name: 'Rol',
          hint: 'Rol',
          icon: 'users',
          value: '',
          type: 'select',
          options: [
            { value: 'Admin', text: 'Admin' }
          ],
          validator: (item, value) => item.role == value
        },
        {
          id: 'platform',
          name: 'Plataforma',
          hint: 'Plataforma',
          icon: 'users',
          value: '',
          type: 'select',
          options: [
            { value: 'acreedores', text: 'Acreedores' },
            { value: 'ahorros', text: 'Ahorros' }
          ],
          validator: (item, value) => item.role == value
        }
      ]
    }
  },
  methods: {
    getItems (page = 1, filters = []) {
      this.tableData.draw++
      let params = this.tableData
      if (filters != null) {
        Object.assign(params, filters)
      } else {
        this.tableData = {
          draw: 1,
          length: 10,
          search: '',
          column: 0,
          dir: 'desc'
        }
        params = this.tableData
      }
      params.page = page
      usersService.list(params)
        .then(response => {
          let data = response
          this.items = data.data
          let meta = data.meta
          this.meta.total = meta.total
          this.meta.total_amount = meta.total_amount
          this.configPagination(data.meta.pagination)
        })
        .catch(errors => {
          console.log(errors)
        })
    },
    configPagination (data) {
      this.pagination.lastPage = data.total_pages
      this.pagination.currentPage = data.current_page
      this.pagination.total = data.total
      this.pagination.links = (data.links) ? data.links : {}
      this.pagination.to = data.count * data.current_page
      this.pagination.from = this.pagination.to - data.count + 1
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/users/Users.vue